import { render, staticRenderFns } from "./IconSort.vue?vue&type=template&id=e9c6f5b4&scoped=true&"
import script from "./IconSort.vue?vue&type=script&lang=ts&"
export * from "./IconSort.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c6f5b4",
  null
  
)

export default component.exports